








































































































































































































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {Collapse, DatePickerWings, SelectWings, SpoilerWings, ToggleWings} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {SystemUserItem} from "@/store/user_management/system_users/types";
import {AllowedPage, UserRoleItem} from "@/store/user_management/roles/types";
import {dynamicSort} from "@/utils/data-helper";
import { TransportItem } from '@/store/transport/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
    SelectWings, DatePickerWings,
    ToggleWings, Collapse, SpoilerWings, CollapseTransition
  }})
export default class SystemUser extends Vue {

  @Ref('validator') validator: any;

  @Action("getSystemUserItem") actionGetItem: any;
  @Action("getSystemPages") actionGetPages: any;
  @Action("saveSystemUser") actionSave: any;
  @Action("deleteSystemUser") actionDelete: any;
  @Action("getUserRoles") actionGetUserRoles: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("actionLog") actionLog: any;

  @Getter("userRoles") rolesList!: UserRoleItem[];
  @Getter("transports") transportsList!: TransportItem[];

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  private expand: object = {
    sms:false,
    call:false,
    email:false,
    push:false,
    viber:false,
    whatsapp:false,
    mail_notify: false,
    custom: false,
    settings:false,
    user_manage:false,
    finance:false,
    cdp:false
  }

  private fieldTypes: any = {
    password: 'text',
  }

  defaultItem(): SystemUserItem {
    return {
      name: '',
      email: '',
      is_check_pass: 0,
      show_finance_info: 1,
      status: 1,
      role_id: undefined,
      system_pages: []
    };
  }

  get transportNames(): string[] {
    return this.transportsList.map((ti: TransportItem) => ti.name);
  }

  async created() {
    this.actionGetUserRoles()
    this.actionGetTransports()
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "System account",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      this.actionGetItem(this.$route.params.id).then((data: SystemUserItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      }).catch(() => {
        this.actionLog({...this.logObject, action_status: "failed"});
      });
    } else {
      this.actionGetPages().then((pages:AllowedPage[]) => {
        pages.map(page=> {
          this.item.system_pages?.push(page)
        })
      })
    }
  }

  back(): void {
    this.$router.push('/user_management/system_users/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          await this.actionSave(this.item);
          await this.logChangeParams('success');
          await this.logChangePassword('success');
          await this.logChangeRole('success');
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.logChangeParams('failed');
          await this.logChangePassword('failed');
          await this.logChangeRole('failed');
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "System account",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  async logChangeParams (action_status: string){
    const fieldsToCompare: Array<keyof SystemUserItem> = ['name', 'email', 'status', 'is_check_pass'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: this.$route.params.id ? "Editing" : "Creation",
      action_status: action_status,
      object_type: "System account",
      object_name: this.item.name,
      addititional_info: getTranslatedParams(this.item)
    }
    await this.actionLog(this.logObject);
  }

  async logChangePassword (action_status: string){
    if (!this.$route.params.id) return;
    if (!this.item.password) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Password change",
      action_status: action_status,
      object_type: "System account",
      addititional_info: getTranslatedParams(this.item)
    }
    await this.actionLog(this.logObject);
  }

  async logChangeRole (action_status: string) {
    if (!this.$route.params.id) return;
    const fieldsToCompare: Array<keyof SystemUserItem> = ['system_pages', 'show_finance_info', 'role_id'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;
    let roleUse = this.isUseRole ? 'Да/Yes' : 'Нет/No';
    let additionalInfo = getTranslatedParams({ role_use: roleUse });

    if (!this.isUseRole) {
      const showFinanceInfo = this.item.show_finance_info === 1 ? 'Да/Yes' : 'Нет/No';
      const getLabel = (all: boolean, some: boolean) => all ? 'Полностью доступен/Fully available' : some ? 'Частично доступен/Partially available' : 'Недоступен/Not available';

      const allSections = {
        'pages.sms': getLabel(this.allPagesSms, this.somePagesSms),
        'pages.call': getLabel(this.allPagesCall, this.somePagesCall),
        'pages.email': getLabel(this.allPagesEmail, this.somePagesEmail),
        'pages.push': getLabel(this.allPagesPush, this.somePagesPush),
        'pages.viber': getLabel(this.allPagesViber, this.somePagesViber),
        'pages.whatsapp': getLabel(this.allPagesWhatsApp, this.somePagesWhatsApp),
        'pages.mail_notify': getLabel(this.allPagesMailNotify, this.somePagesMailNotify),
        'pages.custom': getLabel(this.allPagesCustom, this.somePagesCustom),
        'pages.settings': getLabel(this.allPagesSettings, this.somePagesCustom),
        'pages.user_management': getLabel(this.allPagesUserManage, this.somePagesUserManage),
        'pages.finance': getLabel(this.allPagesFinance, this.somePagesFinance)
      }
      additionalInfo = {'Разделы/Sections': getTranslatedParams(allSections), ...additionalInfo, ...getTranslatedParams({show_finance_info: showFinanceInfo})};
    }else {
      additionalInfo = {...getTranslatedParams({role: this.item.role_name}), ...additionalInfo};
    }

    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Access rights modification",
      action_status: action_status,
      object_type: "System account",
      object_name: this.item.name,
      addititional_info: additionalInfo
    }
    await this.actionLog(this.logObject);
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  onInputPassword(event:any) {
    this.item.password = event
    this.$emit('input', event)
  }

  onInputConfirmPassword(event:any) {
    this.item.confirm_password = event
    this.$emit('input', event)
  }

  get isUseRole():boolean {
    return !!this.item.role_id
  }

  set isUseRole(value:boolean) {
    if (value) {
      this.item.role_id = 1
      if (this.item.system_pages) this.item.system_pages.length = 0;
    } else {
      this.item.role_id = undefined;
      if (!this.item.system_pages || this.item.system_pages.length === 0) this.actionGetPages().then((pages:AllowedPage[]) => {
        pages.map(page=> {
          page.allowed = true
          this.item.system_pages?.push(page)
        })
      })
    }
  }

  get is_check_pass():number {
    return this.item.is_check_pass
  }

  set is_check_pass(value:number) {
    this.item.is_check_pass = (value ?? 0)
  }

  get show_finance_info():number {
    return this.item.show_finance_info
  }

  set show_finance_info(value:number) {
    this.item.show_finance_info = (value ?? 0)
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  get allPagesSms(): boolean {
    return this.pagesSms.every(value => value.allowed)
  }

  set allPagesSms(val:boolean) {
    this.pagesSms.map(value => value.allowed = val)
  }

  get pagesSms() {
    return this.item.system_pages?.filter(value => !value.name.includes('sms.duplicate'))
        .filter(value => value.name.includes('sms')) ?? []
  }

  get somePagesSms(): boolean {
    return this.pagesSms.some(value => value.allowed) && !this.allPagesSms
  }

  get allPagesCall(): boolean {
    return this.pagesCall.every(value => value.allowed)
  }

  set allPagesCall(val:boolean) {
    this.pagesCall.map(value => value.allowed = val)
  }

  get pagesCall() {
    return this.item.system_pages?.filter(value =>
        (value.name.includes('menu.item.call') || value.name.includes('menu.item.statistics.call'))
    ) ?? []
  }

  get somePagesCall(): boolean {
    return this.pagesCall.some(value => value.allowed) && !this.allPagesCall
  }

  get allPagesEmail(): boolean {
    return this.pagesEmail.every(value => value.allowed)
  }

  set allPagesEmail(val:boolean) {
    this.pagesEmail.map(value => value.allowed = val)
  }

  get pagesEmail() {
    return this.item.system_pages?.filter(value => value.name.includes('email')) ?? []
  }

  get somePagesEmail(): boolean {
    return this.pagesEmail.some(value => value.allowed) && !this.allPagesEmail
  }

  get allPagesPush(): boolean {
    return this.pagesPush.every(value => value.allowed)
  }

  set allPagesPush(val:boolean) {
    this.pagesPush.map(value => value.allowed = val)
  }

  get pagesPush() {
    return this.item.system_pages?.filter(value => value.name.includes('push')) ?? []
  }

  get somePagesPush(): boolean {
    return this.pagesPush.some(value => value.allowed) && !this.allPagesPush
  }

  get allPagesViber(): boolean {
    return this.pagesViber.every(value => value.allowed)
  }

  set allPagesViber(val:boolean) {
    this.pagesViber.map(value => value.allowed = val)
  }

  get pagesViber() {
    return this.item.system_pages?.filter(value => value.name.includes('viber')) ?? []
  }

  get somePagesViber(): boolean {
    return this.pagesViber.some(value => value.allowed) && !this.allPagesViber
  }

  get allPagesWhatsApp(): boolean {
    return this.pagesWhatsApp.every(value => value.allowed)
  }

  set allPagesWhatsApp(val:boolean) {
    this.pagesWhatsApp.map(value => value.allowed = val)
  }

  get pagesWhatsApp() {
    return this.item.system_pages?.filter(value => value.name.includes('whatsapp')) ?? []
  }

  get somePagesWhatsApp(): boolean {
    return this.pagesWhatsApp.some(value => value.allowed) && !this.allPagesWhatsApp
  }

  get allPagesMailNotify(): boolean {
    return this.pagesMailNotify.every(value => value.allowed)
  }

  set allPagesMailNotify(val:boolean) {
    this.pagesMailNotify.map(value => value.allowed = val)
  }

  get pagesMailNotify() {
    return this.item.system_pages?.filter(value => value.name.includes('mail_notify')) ?? []
  }

  get somePagesMailNotify(): boolean {
    return this.pagesMailNotify.some(value => value.allowed) && !this.allPagesMailNotify
  }

  get allPagesCustom(): boolean {
    return this.pagesCustom.every(value => value.allowed)
  }

  set allPagesCustom(val:boolean) {
    this.pagesCustom.map(value => value.allowed = val)
  }

  get pagesCustom() {
    return this.item.system_pages?.filter(value => value.name.includes('custom') 
        && !value.name.includes('menu.item.custom.mo.routing')) ?? []
  }

  get somePagesCustom(): boolean {
    return this.pagesCustom.some(value => value.allowed) && !this.allPagesCustom
  }

  get allPagesSettings(): boolean {
    return this.pagesSettings.every(value => value.allowed)
  }

  set allPagesSettings(val:boolean) {
    this.pagesSettings.map(value => value.allowed = val)
  }

  get pagesSettings() {
    return this.item.system_pages?.filter(value => (value.name.includes('menu.item.settings')
            || value.name.includes('menu.item.statistics.export.reports') 
            || value.name.includes('menu.item.settings.duplicate'))
        && !value.name.includes('menu.item.settings.pool')) ?? []
  }

  get somePagesSettings(): boolean {
    return this.pagesSettings.some(value => value.allowed) && !this.allPagesSettings
  }

  get allPagesUserManage(): boolean {
    return this.pagesUserManage.every(value => value.allowed)
  }

  set allPagesUserManage(val:boolean) {
    this.pagesUserManage.map(value => value.allowed = val)
  }

  get pagesUserManage() {
    return this.item.system_pages?.filter(value => (value.name.includes('user.manage') || value.name.includes('distr'))).sort(dynamicSort("name", "asc")) ?? []
  }

  get somePagesUserManage(): boolean {
    return this.pagesUserManage.some(value => value.allowed) && !this.allPagesUserManage
  }

  get allPagesFinance(): boolean {
    return this.pagesFinance.every(value => value.allowed)
  }

  set allPagesFinance(val:boolean) {
    this.pagesFinance.map(value => value.allowed = val)
  }

  get pagesFinance() {
    return this.item.system_pages?.filter(value => value.name.includes('finance')) ?? []
  }

  get somePagesFinance(): boolean {
    return this.pagesFinance.some(value => value.allowed) && !this.allPagesFinance
  }

  get allPagesCdp(): boolean {
    return this.pagesCdp.every(value => value.allowed)
  }

  set allPagesCdp(val:boolean) {
    this.pagesCdp.map(value => value.allowed = val)
  }

  get pagesCdp() {
    return this.item.system_pages?.filter(value => 
        value.name.includes('menu.item.cdp_settings')
        || value.name.includes('menu.item.statistics.cdp')) ?? []
  }

  get somePagesCdp(): boolean {
    return this.pagesCdp.some(value => value.allowed) && !this.allPagesCdp
  }
}
